import dayjs from 'dayjs'
import { DaylightDateFormat } from '@/constants/DaylightDateFormat'

/**
 * Mock Trend Graph Data
 * Matches the actual API response structure
 */
export const mockTrendGraph = {
  success: true,
  start: dayjs().subtract(7, 'days').unix(),
  end: dayjs().unix(),
  interval: 86400, // 1 day in seconds
  data: [
    {
      timestamp: dayjs().subtract(6, 'days').unix(),
      date: dayjs().subtract(6, 'days').format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 12 }],
    },
    {
      timestamp: dayjs().subtract(5, 'days').unix(),
      date: dayjs().subtract(5, 'days').format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 8 }],
    },
    {
      timestamp: dayjs().subtract(4, 'days').unix(),
      date: dayjs().subtract(4, 'days').format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 15 }],
    },
    {
      timestamp: dayjs().subtract(3, 'days').unix(),
      date: dayjs().subtract(3, 'days').format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 20 }],
    },
    {
      timestamp: dayjs().subtract(2, 'days').unix(),
      date: dayjs().subtract(2, 'days').format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 18 }],
    },
    {
      timestamp: dayjs().subtract(1, 'day').unix(),
      date: dayjs().subtract(1, 'day').format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 10 }],
    },
    {
      timestamp: dayjs().unix(),
      date: dayjs().format(DaylightDateFormat.ISO_DATE),
      count: [{ count: 5 }],
    },
  ],
}
